import { render, staticRenderFns } from "./MontagemCargaPorCteDetalhes.vue?vue&type=template&id=6250a528"
import script from "./MontagemCargaPorCteDetalhes.vue?vue&type=script&lang=js"
export * from "./MontagemCargaPorCteDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports